import React from 'react';
import { FadeIn, CTAButton, Section, SectionTitle, Accent } from './Shared';
import { ProductVideo } from './ProductVideo';
import { featuredTestimonials } from '../data/testimonials';
import { ShieldCheck, Lock, Globe2, Star, X, ArrowRightIcon, FileTextIcon, ZapIcon, LayersIcon, TrophyIcon } from 'lucide-react';
const HERO_MOCKUP = 'https://cdn.magicpatterns.com/uploads/4uX3G3wUEjM6S8x4n4MirU/MOCKUP_PRINCIPAL.png';
const PRODUCT_VIDEO = 'https://cdn.magicpatterns.com/uploads/gU2Fgk8LqeyNecoZp1uU4n/VIDEO%20DE%20CUADERNOS.mp4';
export const Hero = () => {
  const chips = [{
    icon: FileTextIcon,
    label: '100% PDF'
  }, {
    icon: ZapIcon,
    label: 'Access in 5 min'
  }, {
    icon: LayersIcon,
    label: '365 sessions'
  }];
  return <section className="relative overflow-hidden border-b border-white/5 bg-slate-950" data-id="element-291" data-mp="dyhfqgh34m1s">
      {/* Subtle top light — solid, not a gradient */}
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-sky-400/40" aria-hidden="true" data-id="element-292" data-mp="1pf7q8bsjk017" />
      <div className="mx-auto grid max-w-6xl items-center gap-6 px-5 pb-14 pt-8 md:px-8 md:pb-20 md:pt-14 lg:grid-cols-[1fr_1.15fr] lg:gap-x-12 lg:gap-y-8" data-id="element-293" data-mp="1h99avmkgkgxp">
        {/* Headline */}
        <FadeIn className="text-center lg:col-start-1 lg:row-start-1 lg:self-end lg:text-left" data-id="element-294" data-mp="1894ahwdomit1">
          <p className="mb-4 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-sky-400" data-id="element-295" data-mp="13b2jmpa0lf70">
            <span className="h-1.5 w-1.5 rounded-full bg-sky-400" aria-hidden="true" data-id="element-296" data-mp="yc82rsvly0pj" />
            Functional Fitness 365™
          </p>
          <h1 className="font-display text-[38px] font-black uppercase italic leading-[0.92] tracking-tight text-white sm:text-5xl md:text-6xl lg:text-[68px]" data-id="element-297" data-mp="tin3zym6x2pa">
            Plan your entire year of <Accent data-id="element-298" data-mp="klw6rivwjht4">functional</Accent> classes.
            <span className="mt-1 block text-slate-400" data-id="element-299" data-mp="flhx5wenjzsz">In 5 minutes.</span>
          </h1>
          <p className="mx-auto mt-5 max-w-md text-base leading-relaxed text-slate-300 md:text-lg lg:mx-0" data-id="element-300" data-mp="am5e7mqwjcvo">
            365 ready-to-teach sessions — whether you're a seasoned coach or
            just getting started.
          </p>
        </FadeIn>

        {/* Mockup */}
        <FadeIn delay={0.1} className="lg:col-start-2 lg:row-span-2 lg:row-start-1" data-id="element-301" data-mp="5v9r94adct72">
          <a href="#pricing" className="group block" aria-label="See the offer" data-id="element-302" data-mp="3n7aq6r0mxhah">
            <img src={HERO_MOCKUP} alt="Functional Fitness 365 — the 6 volumes, bonus pack and digital access on tablet, desktop and phone" width={1536} height={1024} loading="eager" decoding="async"
          // @ts-ignore fetchpriority is valid HTML
          fetchpriority="high" className="mx-auto block h-auto w-full max-w-[560px] object-contain transition-transform duration-200 ease-out group-hover:-translate-y-1 lg:max-w-none" data-id="element-303" data-mp="3s5ccrlx9ryqp" />
          </a>
        </FadeIn>

        {/* CTA */}
        <FadeIn delay={0.15} className="lg:col-start-1 lg:row-start-2 lg:self-start" data-id="element-304" data-mp="17fwmcs1yqc1l">
          <ul className="mb-5 flex flex-wrap items-center justify-center gap-2 lg:justify-start" data-id="element-305" data-mp="2s3ftzaj4q9ge">
            {chips.map(({
            icon: Icon,
            label
          }) => <li key={label} className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-xs font-medium text-slate-200 md:text-sm" data-id="element-306" data-mp="31uk704p8vk8l">
                <Icon size={14} className="text-sky-400" aria-hidden="true" data-id="element-307" data-mp="296o4gjczuy3w" />
                {label}
              </li>)}
          </ul>
          <CTAButton href="#pricing" className="w-full sm:w-auto" data-id="element-308" data-mp="2i6kzd2pz8t7e">
            Get Functional Fitness 365
            <ArrowRightIcon size={18} className="transition-transform duration-200 group-hover/cta:translate-x-0.5" aria-hidden="true" data-id="element-309" data-mp="2e57rkn3bqfxu" />
          </CTAButton>
          <div className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-xs text-slate-400 lg:justify-start" data-id="element-310" data-mp="3tjwump7o83hy">
            <span className="flex items-center gap-1.5" data-id="element-311" data-mp="oox4pjtihkoo">
              <ShieldCheck size={14} className="text-emerald-400" aria-hidden="true" data-id="element-312" data-mp="oqhxp506gvkf" /> 7-day guarantee
            </span>
            <span className="flex items-center gap-1.5" data-id="element-313" data-mp="sslco3m22iag">
              <Lock size={14} aria-hidden="true" data-id="element-314" data-mp="xok7oa1w2yju" /> Secure checkout
            </span>
            <span className="flex items-center gap-1.5" data-id="element-315" data-mp="12oyczkc3vue6">
              <Globe2 size={14} className="text-sky-400" aria-hidden="true" data-id="element-316" data-mp="12mbwgv78m4jt" /> Pay in your local currency
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const SocialProof = () => {
  const stats = [{
    value: '+500',
    label: 'coaches trust it'
  }, {
    value: '6',
    label: 'ready volumes'
  }, {
    value: '5',
    label: 'bonuses included'
  }, {
    value: '4.9/5',
    label: 'average rating',
    star: true
  }];
  return <div className="border-b border-white/5 bg-slate-900/40 px-5 py-8 md:px-8" data-id="element-317" data-mp="1qfc0cxjqx52f">
      <dl className="mx-auto grid max-w-6xl grid-cols-2 gap-y-6 md:grid-cols-4" data-id="element-318" data-mp="1vckhcut5r323">
        {stats.map((s, i) => <FadeIn key={s.label} delay={Math.min(i * 0.05, 0.2)} className={`text-center ${i % 2 === 1 ? 'border-l border-white/10' : ''} ${i > 0 ? 'md:border-l md:border-white/10' : ''}`} data-id="element-319" data-mp="3fwfrk31rdtww" data-mpi={i}>
            <dt className="sr-only" data-id="element-320" data-mp="35wfa6mng9nvc">{s.label}</dt>
            <dd className="font-display text-4xl font-black italic leading-none tracking-tight text-white md:text-5xl" data-id="element-321" data-mp="35zb84azascjs">
              {s.value}
            </dd>
            <dd className="mt-2 flex items-center justify-center gap-1 text-sm text-slate-400" data-id="element-322" data-mp="2f6ry1ot8m03">
              {s.label}
              {s.star && <Star size={12} className="fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-323" data-mp="3tow0fkhccm5q" />}
            </dd>
          </FadeIn>)}
      </dl>
    </div>;
};
const Stars = ({
  size = 12
}: {
  size?: number;
}) => <div className="flex text-amber-400" role="img" aria-label="5 out of 5 stars" data-id="element-324" data-mp="l6zkjuzyw57a">
    {[...Array(5)].map((_, j) => <Star key={j} size={size} className="fill-current" aria-hidden="true" data-id="element-325" data-mp="gfrbj02julun" data-mpi={j} />)}
  </div>;
export const Testimonials1 = () => <Section className="bg-slate-950 !py-12 md:!py-16" data-id="element-326" data-mp="2apg01h2og5xe">
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3" data-id="element-327" data-mp="2fn7zcw5niubm">
      {featuredTestimonials.map((t, i) => <FadeIn key={t.author} delay={Math.min(i * 0.05, 0.2)} data-id="element-328" data-mp="20yl9w1mb8m6o" data-mpi={i}>
          <figure className="flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.03] p-5 md:p-6" data-id="element-329" data-mp="20w7ko9eba471">
            <Stars data-id="element-330" data-mp="25v23hbca3sr5" />
            <blockquote className="mt-3 text-[15px] leading-relaxed text-slate-200" data-id="element-331" data-mp="1rx4010zhxgqf">
              “{t.text}”
            </blockquote>
            <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-332" data-mp="1w00au5iso8jt">
              <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${t.bg} text-xs font-bold text-white`} data-id="element-333" data-mp="1i092oleylmdq">
                {t.initials}
              </div>
              <div className="min-w-0" data-id="element-334" data-mp="3cdqitnd1bgyq">
                <p className="text-sm font-semibold leading-tight text-white" data-id="element-335" data-mp="3ces1oe0al7r0">{t.author}</p>
                <p className="text-xs text-slate-500" data-id="element-336" data-mp="3hb8tbi6pa48u">{t.role}</p>
              </div>
            </figcaption>
          </figure>
        </FadeIn>)}
    </div>
  </Section>;
export { Stars };
export const Problem = () => {
  const painPoints = ["You walk into the gym not knowing exactly what class you're teaching today", 'You spend hours hunting for exercises that fit your group', "You repeat the same circuits because you don't have a session library", "A new member shows up and you don't know how to adapt on the spot", "You want a yearly program but have no time to build one", 'Your group plateaus every time you try to give them real progression', 'Weekends searching for ideas. Mondays improvising. Same cycle.'];
  return <Section className="bg-slate-900/40" data-id="element-337" data-mp="1te9dwcnil77i">
      <FadeIn data-id="element-338" data-mp="1tfc22ctgcvjq">
        <SectionTitle data-id="element-339" data-mp="1tcpvogiasm33">
          If you coach <Accent data-id="element-340" data-mp="3zcn2f35kbw6">functional fitness</Accent>,
          <br className="hidden md:block" data-id="element-341" data-mp="40e8ndhsogs5" /> this will sound familiar…
        </SectionTitle>
      </FadeIn>

      <ul className="mx-auto mb-16 grid max-w-4xl grid-cols-1 gap-x-8 gap-y-1 md:mb-24 md:grid-cols-2" data-id="element-342" data-mp="3v808sw5b2149">
        {painPoints.map((point, i) => <li key={point} className={`flex items-start gap-3 border-b border-white/5 py-3.5 ${i === painPoints.length - 1 ? 'md:col-span-2 md:mx-auto md:max-w-md md:border-b-0' : ''}`} data-id="element-343" data-mp="3ebjliwmyj8nt" data-mpi={i}>
            <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-500/15" data-id="element-344" data-mp="3o1mqlv7csd2i">
              <X size={12} className="text-red-400" strokeWidth={3} aria-hidden="true" data-id="element-345" data-mp="2qensrh4xcz31" />
            </span>
            <p className="text-[15px] leading-normal text-slate-300 md:text-base" data-id="element-346" data-mp="2vcfiq5m0eb4l">{point}</p>
          </li>)}
      </ul>

      <FadeIn className="mx-auto mb-12 grid max-w-5xl items-center gap-6 md:mb-16 md:grid-cols-2 md:gap-12" data-id="element-347" data-mp="30aqs6f8e6jma">
        <h3 className="text-center font-display text-4xl font-black uppercase italic leading-[0.92] tracking-tight text-white md:text-left md:text-6xl" data-id="element-348" data-mp="34f8a08v6ymuf">
          Still <Accent data-id="element-349" data-mp="jmwl9pk4k9gc">improvising</Accent> your workouts?
        </h3>
        <div className="space-y-4 text-base leading-relaxed text-slate-300 md:text-lg" data-id="element-350" data-mp="245paf6i33s35">
          <p data-id="element-351" data-mp="247jkfprthzsg">
            You chose this profession because you love functional training and
            watching your group grow.
          </p>
          <p data-id="element-352" data-mp="1vcdcak52r5mr">
            Whether you're a seasoned coach or just starting out, the problem
            is the same: you spend more time <strong className="font-semibold text-white" data-id="element-353" data-mp="1qdslfbbppyaz">SEARCHING</strong> for what to
            teach than actually <strong className="font-semibold text-white" data-id="element-354" data-mp="1lgirbiddoygt">TEACHING</strong>. And while you lose your
            Sundays building sessions, your competitors keep moving ahead.
          </p>
        </div>
      </FadeIn>

      <FadeIn className="mx-auto max-w-3xl" data-id="element-355" data-mp="1cgdu211wfggd">
        <div className="rounded-3xl border border-sky-400/40 bg-blue-600/10 px-6 py-8 text-center md:px-10 md:py-10" data-id="element-356" data-mp="17g7u7xlh6nn7">
          <p className="font-display text-2xl font-black uppercase italic leading-[1.02] tracking-tight text-white md:text-4xl" data-id="element-357" data-mp="36r8ycr61w9dc">
            What if this was the <Accent data-id="element-358" data-mp="ibejgy0eeos6">last class</Accent>
            <br data-id="element-359" data-mp="iabtqtetasdu" /> you ever prepared this way?
          </p>
        </div>
      </FadeIn>

      <FadeIn className="mt-20 text-center md:mt-28" data-id="element-360" data-mp="ddd4ao63f9lz">
        <p className="mb-5 inline-flex items-center gap-2 rounded-full bg-amber-400 px-3.5 py-1.5 text-xs font-bold uppercase tracking-wide text-amber-950" data-id="element-361" data-mp="dewgo3omp0ih">
          <TrophyIcon size={14} aria-hidden="true" data-id="element-362" data-mp="mejlkzgkgoga" />
          The #1 system for functional fitness coaches
        </p>
        <h2 className="font-display text-4xl font-black uppercase italic leading-[0.95] tracking-tight text-white md:text-6xl" data-id="element-363" data-mp="3utbeybglxmz9">
          Functional Fitness <Accent data-id="element-364" data-mp="8e0ga03hjwht">365™</Accent>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-slate-300 md:text-lg" data-id="element-365" data-mp="8f1qk2cogeyh">
          6 Volumes + 5 Bonuses — 365 ready sessions · A full year · Everything
          solved.
        </p>

        <div className="relative mx-auto mt-10 max-w-3xl overflow-hidden rounded-3xl border border-white/10 bg-slate-900 shadow-2xl shadow-black/50" data-id="element-366" data-mp="3c0r2g4l7tuhm">
          <ProductVideo src={PRODUCT_VIDEO} label="Preview of the Functional Fitness 365 workbooks" className="block w-full object-cover" data-id="element-367" data-mp="1mkwvakd80das" />
        </div>
      </FadeIn>
    </Section>;
};